<div mat-dialog-title class="d-flex justify-content-between align-items-center">
  <h2 class="m-0">Domain mapping</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div class="conversion-row">
    <h4 class="rerd_heading">Add the domain you want to map</h4>
    <mat-form-field appearance="outline" class="conversion-field">
      <mat-label>Domain name</mat-label>
      <input [disabled]="domainData?.mapping_status == 1" [(ngModel)]="domainName" matInput type="text" />
    </mat-form-field>
  </div>

  <div class="peod_checkopen">
    <p>
      Add the domain you own for your business. Map with LookzUp and give access
      to your services and offerings in your branded website and app. Your
      business mobile app + website with the business logo, color theme and
      branding immediately establishes trust and professionalism.
    </p>
  </div>
  <div style=" display: flex;    margin-top: 25px;" *ngIf="domainData?.mapping_status == 1">
    <mat-icon style="color: green;margin-right: 10px;">check</mat-icon>
    <p style="color: #888;">Domain mapped.</p>
  </div>
  
  <div *ngIf="!domainData?.mapping_status || domainData?.mapping_status == 0" style=" display: flex;    margin-top: 25px;">
    <mat-icon style="color: red;margin-right: 10px;">close</mat-icon>
    <p style="color: #888;">No domain mapped yet.</p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" *ngIf="!domainData?.mapping_status || domainData?.mapping_status == 0">
  <!-- <button mat-button mat-dialog-close>Cancel</button> -->
  <button mat-flat-button color="accent" (click)="onsave()" [disabled]="isSaveDisabled">Save</button>
</mat-dialog-actions>
<mat-dialog-actions align="end" *ngIf="domainData?.mapping_status == 1">
  <!-- <button mat-button mat-dialog-close>Ok</button> -->
  <button mat-flat-button color="accent" mat-dialog-close>Ok</button>
</mat-dialog-actions>
